import { FC } from 'react';

import './Loader.css';

const Loader: FC = () => (
  <div className="loader">
    <div className="loader-spinner"></div>
  </div>
);

export default Loader;
